<template>
    <a
        v-if="banner.banner_type === 'image'"
        :href="banner.link"
        :class="['slide', 'slide--link', { 'current-slide': isActive }]"
    >
        <img :src="banner.image_url" :alt="banner.title || ''" class="slide__img">
    </a>
    <div v-else :class="['slide', { 'current-slide': isActive }]">
        <div class="content">
            <div class="title">{{ banner.title }}</div>
            <hr style="margin-top: 0;">
            <div class="text" v-html="banner.content"></div>
            <a
                v-if="banner.cta_text && banner.link"
                :href="banner.link"
                class="btn btn-cta"
            >
                {{ banner.cta_text }}
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            banner: {
                type: Object,
                required: true,
            },
            isActive: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style scoped lang="scss">
    .slide
    {
        position: absolute;
        inset: 0;
        opacity: 0;
        padding: 30px 40px;
        display: flex;
        align-items: stretch;
        border-radius: 10px;
        z-index: 1;
        transition: opacity 1s;
        min-height: 320px;

        .content
        {
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .title
        {
            font-size: 2em;
            line-height: 1.1em;
            font-weight: 600;
            margin-bottom: 15px;
            color: $white;
            background: url('../assets/images/swift-logo.png') no-repeat left center;
            background-size: contain;
            padding-left: 60px;

            @include media-breakpoint-up(xxl)
            {
                font-size: 2.4em;
            }
        }

        .text
        {
            flex-grow: 1;
            font-size: 1.3em;
            color: $white;
            line-height: 1.3em;
            margin-bottom: 25px;

            @include media-breakpoint-up(xxl)
            {
                font-size: 1.5em;
            }
        }

        .btn-cta
        {
            align-self: flex-start;
            background: $swift-fresh-green;
            color: $swift-not-black;
            border-radius: 30px;
            padding: 10px 30px;
            font-size: 1.1em;
            font-weight: 600;
            text-decoration: none;

            &:hover
            {
                opacity: 0.9;
            }
        }

        &.slide--link
        {
            display: block;
            padding: 0;
            text-decoration: none;
            width: 100%;
        }

        .slide__img
        {
            display: block;
            width: 100%;
            height: auto;
        }
    }

    .current-slide
    {
        position: relative;
        inset: auto;
        z-index: 2;
        opacity: 1;
        transition: opacity 1s;
    }
</style>
